// Global site settings — contact details, hours, social links, footer links.
// Every component reads these values from here, so changing them once updates the whole site.
// Later this will come from the backend "Site Settings" model.

const siteConfig = {
  name: "Unity Health Centre",
  shortName: "Unity Health",
  tagline: "Mental Health, Psychiatric & Addiction Treatment Hospital",
  description:
    "Unity Health Centre is a specialized mental health, psychiatric and addiction treatment hospital in Kishoreganj, offering ethical, confidential and evidence-based care.",

  logo: {
    light: "/images/logo_light.png",
    dark: "/images/logo_main.png",
    icon: "/images/short_logo.png",
  },

  contact: {
    phone: "+8801936209467",
    phoneDisplay: "01936209467",
    emergencyPhone: "+8801936209467",
    emergencyPhoneDisplay: "01936209467",
    whatsapp: "8801936209467", // international format, digits only
    email: "info@unityhealthbd.com",
    address: "Near Circuit House, Gaital, Kishoreganj",
    addressFull: "Near Circuit House, Gaital, Kishoreganj-2300, Bangladesh",
    city: "Kishoreganj",
    country: "BD",
  },

  // Used in search-engine data (OrganizationSchema)
  specialties: ["Psychiatric", "Addiction Medicine"],

  // Site-wide images (banners, backgrounds). Admin can replace these later.
  images: {
    pageBanner: "/assets/images/page-titles/8.jpg",
    doctorBanner: "/assets/images/backgrounds/7.jpg",
    detailBanner: "/assets/images/backgrounds/6.jpg",
    serviceDetail: "/assets/images/banners/7.jpg",
    contactPanel: "/assets/images/banners/1.jpg",
    helpWidget: "/assets/images/banners/5.jpg",
    servicesBg: "/assets/images/backgrounds/2.jpg",
    ctaIcon: "/assets/images/icons/alert.png",
    map: "/assets/images/backgrounds/map.png",
    notFound: "/images/error.png",
    videoFallback: "/assets/images/banners/7.jpg",
    shareDefault: "/assets/images/sliders/1.jpg",
  },

  map: {
    embedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d321.01090771624763!2d90.77597987691264!3d24.456896574068857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375692412f001e17%3A0x35f381b367f88b4d!2z4Ka44Ka-4Kaw4KeN4KaV4Ka_4KafIOCmueCmvuCmieCmuCwg4KaV4Ka_4Ka24KeL4Kaw4KaX4Kae4KeN4Kac!5e0!3m2!1sbn!2sbd!4v1769402250192!5m2!1sbn!2sbd",
    directionsUrl:
      "https://www.google.com/maps?ll=24.456752,90.776374&z=20&t=m&hl=bn&gl=BD&mapclient=embed&cid=3887593510894340941",
  },

  // Short form used in the top bar and small widgets
  hoursSummary: "SAT - THU : 8:00 am - 10:00 pm",
  openingHours: [
    { days: "Sat - Thu", time: "8.00 - 10:00 pm" },
    { days: "Friday", time: "OPD Closed" },
    { days: "Emergency", time: "24 / 7" },
  ],
  timetableNote:
    "Friday: OPD closed. Inpatient and emergency services remain open 24/7.",

  // Social links shown in the header top bar and footer (empty = "#" placeholder link)
  social: {
    facebook: "",
    instagram: "",
    x: "",
  },

  // Live chat (Tawk.to). Create a free account at tawk.to, then paste the IDs from
  // Administration → Chat Widget (https://embed.tawk.to/<propertyId>/<widgetId>). Empty = chat hidden.
  liveChat: {
    tawkPropertyId: "6ad233f8a5f76b34ccd3a130",
    tawkWidgetId: "1k52hm1h8",
  },

  // Pre-filled text for the floating WhatsApp button
  whatsappMessage:
    "Hello Unity Health Centre, I would like to know about treatment.",

  intro: {
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
  },

  footer: {
    about:
      "Unity Health Centre is a professional mental health and addiction treatment hospital dedicated to ethical care, confidentiality, and long-term recovery. Our experienced team ensures compassionate treatment following international standards.",
    quickLinks: [
      { label: "About Us", to: "/about" },
      { label: "Packages", to: "/packages" },
      { label: "Services", to: "/services" },
      { label: "Our Consultants", to: "/doctors" },
      { label: "Gallery", to: "/gallery" },
      { label: "Blogs", to: "/blog" },
      { label: "Contact Us", to: "/contact" },
    ],
    otherLinks: [
      { label: "Appointment", to: "/appointment" },
      { label: "Doctors' Timetable", to: "/time-table" },
      { label: "Free Self-Assessment", to: "/self-assessment" },
      { label: "Admission Enquiry", to: "/admission" },
      { label: "FAQ", to: "/faq" },
      { label: "Terms & Conditions", to: "/terms-and-conditions" },
      { label: "Privacy Policy", to: "/privacy-policy" },
    ],
    copyrightYear: 2026,
    developer: { name: "ASTROSOFT BD", url: "https://www.astrosoftbd.com" },
  },
};

export default siteConfig;
